import type { Project } from "../types/Project";

type ProjectCardProps = {
  project: Project;
  index: number;
  onOpen: (project: Project) => void;
  onFocus: (index: number) => void;
};

export function ProjectCard({
  project,
  index,
  onOpen,
  onFocus,
}: ProjectCardProps) {
  return (
    <button
      onClick={() => onOpen(project)}
      onFocus={() => onFocus(index)}
      className="group text-left border border-white/15 p-3.5 transition-colors duration-200 outline-none flex flex-col hover:border-white/30"
    >
      <h3 className="text-xl font-semibold tracking-tight mb-2.5 group-hover:text-white/90 transition-colors">
        {project.title}
      </h3>
      <p className="text-white/50 text-sm leading-relaxed mb-3.5 grow">
        {project.summary}
      </p>

      <div className="border border-white/15 aspect-video bg-[#0f0f0f] overflow-hidden mb-3.5">
        <img
          src="/screenshots/okktav/okktav-1.png"
          alt={project.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-white/50" />
        <span className="w-1.5 h-1.5 rounded-full bg-white/20" />
        <span className="w-1.5 h-1.5 rounded-full bg-white/20" />
      </div>
    </button>
  );
}
